import axios from 'axios';

import Utils from '@/common/utils';

export default {
  search: function (request) {
    return axios.get(`/api/worldprice/search`, { params: request });
  },
  find: function (id) {
    return axios.get(`/api/worldprice/find?id=${id}`);
  },
  update: function (id, request) {
    if (id > 0) return axios.put(`/api/worldprice/update`, request);
    else return axios.post(`/api/worldprice/create`, request);
  },
  delete: function (id) {
    return axios.delete(`/api/worldprice/delete?id=${id}`);
  },
  getTemplate: function () {
    return Utils.downloadFile('/api/worldprice/template', 'WorldpriceTemplate.xlsx');
  },
  uploadFile: function (file) {
    let formData = new FormData();
    formData.append('file', file);
    return axios.post(`/api/worldprice/upload`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  yearList: function (id) {
    return axios.get(`/api/worldprice/yearList?countryId=${id}`);
  },
};
